import { useEffect, useState } from 'react';

import CourseAPI from '../../course/CourseAPI';
import Course from '../../course/types/Course';
import { Permission } from '../../user/types/Permission';
import { useUser } from '../../user/userContext';
import { userHasPermission } from '../../user/userUtils';

export function useCourses() {
  const [currentUser] = useUser();
  const [courses, setCourses] = useState<Course[]>([]);

  const canReadCourses = userHasPermission(
    currentUser,
    Permission.COURSE_READ_LIST,
  );
  useEffect(() => {
    if (!canReadCourses) return;

    CourseAPI.getCourses()
      .then(({ data }) => setCourses(data))
      .catch(() => {});
  }, [canReadCourses]);

  return { canReadCourses, courses };
}
